import { render, staticRenderFns } from "./emoji_list.vue?vue&type=template&id=4a367adc"
import script from "./emoji_list.vue?vue&type=script&lang=js"
export * from "./emoji_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports